import React from "react";

const SeePaginatorButton = ({seeProducts, context, className, title, label}) => {
    return (
        <>
            <a className={className}
               onClick={(e) => seeProducts(e, context)}
               title={title}> {label}</a>
        </>
    )
}
export default SeePaginatorButton;